<template>
  <div id="index">


    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="$refs.addEdit.show()" icon="el-icon-plus" v-auth="'/need/business/add'">添加业务</el-button>
    </div>

    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="list" >
          <el-table-column prop="name" label="业务名称"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button @click="$refs.addEdit.show(scope.row)" type="text" size="small" v-auth="'/need/business/edit'">编辑</el-button>
              <el-button @click="deleteTap(scope.row)" type="text" size="small" v-auth="'/need/business/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="pagination">
      <el-pagination
        @current-change="pageChange"
        background
        :current-page="searchObj.page"
        :page-size="searchObj.list_rows"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>


    <AddEdit ref="addEdit"  @refresh="getData"></AddEdit>


  </div>
  </template>

  <script>
  import AddEdit from './addEdit.vue';
  import NeedApi from '@/api/need'
  export default {
    components:{AddEdit},
    data() {
      return {
        searchObj:{
          page:1,
          list_rows:10,
        },
        list: [],
        total:0,
      }
    },
    created(){
      this.getData()
    },
    methods:{

      getData(){
        NeedApi.businessIndex(this.searchObj).then(result=>{
          let list=result.data.business
          this.list=list.data
          this.total=list.total
        })
      },

      // 删除
      deleteTap(e){
        this.$confirm('确认删除当前业务吗？','提示',{type: 'warning'}).then(() => {
          NeedApi.businessDelete({business_id:e.business_id}).then(result=>{
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getData()
          })
        })
      },

      // 分页
      pageChange(e){
        this.searchObj.page=e
        this.getData()
      },

    }
  }
  </script>

  <style lang="scss" scoped>
  </style>


// WEBPACK FOOTER //
// src/views/need/business/index.vue